export enum RouterActionType {
  Deposit = 0,
  Withdraw = 1,
  Borrow = 2,
  Repay = 3,
  Wrap = 4,
  Unwrap = 5,
}
